<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    //- Top bar
    v-card-title.px-4
      v-btn.mr-2(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
      .text-2xl.font-semibold Vital signs
      v-spacer
      
    v-card-text.neutral700--text(outlined)
      .d-flex.justify-center.my-6
        div(style="width: 90%;")
          //- New Input
          div
            v-row
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Date
                y-dialog(v-model='showPicker' width='380px' persistent content-class="round-3xl")
                  template(v-slot:activator='{ on }')
                    v-text-field.text-sm.mt-2.round-xl(v-model="selectedDateField" placeholder="DD/MM/YYYY" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" v-on="on" readonly)
                      template(v-slot:append)
                        eva-icon(name="calendar-outline" fill="#848484" style="margin-top: 2px;")
                  v-card
                    v-card-text.px-2.pt-2.pb-0
                      yc-date-picker(:parentDate.sync="selectedDate" color="info" @change="pickDate(selectedDate)")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Time
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
            
            v-row
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Height
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.height" placeholder="0" outlined dense height="48" suffix="cm" type="number" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Weight
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.weight" placeholder="0" outlined dense height="48" suffix="kg" type="number" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Blood pressure
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.blood_pressure" placeholder="0/0" outlined dense height="48" :rules="sign.blood_pressure ? rules.valid_blood_pressure : []" suffix="mmHg" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Pulse
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.pulse" placeholder="0" outlined dense height="48" suffix="bpm" type="number" hide-details="auto")
            
            v-row
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Temperature
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.temperature" placeholder="0" outlined dense height="48" suffix="°C" type="number" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Blood glucose
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.blood_glucose" placeholder="0" outlined dense height="48" suffix="mmol/L" type="number" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text SpO2
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.spo2" placeholder="0" outlined dense height="48" suffix="%" type="number" hide-details="auto")
              v-col(cols="3")
                div.text-sm.font-semibold.neutral500--text Respiratory rate
                v-text-field.text-sm.mt-2.round-xl(v-model="sign.respiratory_rate" placeholder="0" outlined dense height="48" suffix="breath per min" type="number" hide-details="auto")

            div.d-flex.align-center.mt-5
              v-spacer
              y-button(label="Save new" size="md" :loading="isLoading" @click="saveNewSign")

          //- Vital records
          div
            div.text-md.font-semibold.neutral700--text.mt-6 Vital records
            v-data-table.custom-style.mt-2(:headers="headers" :items="signs" hide-default-footer disable-sort loader-height="2" :items-per-page="-1" :loading="isFetching")
              //- No data
              template(v-slot:no-data)
                div No data
              //- Date
              template(v-slot:item.date="{ item, index }")
                y-dialog(v-if="item.editable" v-model='showTablePicker' width='380px' persistent content-class="round-3xl")
                  template(v-slot:activator='{ on }')
                    v-text-field.text-sm.my-2.round-xl(v-model="item.field_date" placeholder="DD/MM/YYYY" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" v-on="on" readonly)
                      template(v-slot:append)
                        eva-icon(name="calendar-outline" fill="#848484" style="margin-top: 2px;")
                  v-card
                    v-card-text.px-2.pt-2.pb-0
                      yc-date-picker(:parentDate.sync="item.date" color="info" @change="pickTableDate(item)")
                div(v-else) {{ item.field_date }}
              //- Time
              template(v-slot:item.time="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                div(v-else) {{ item.time | displayTime2 }}
              //- Height
              template(v-slot:item.height="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.height" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.height }}
              //- Weight
              template(v-slot:item.weight="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.weight" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.weight }}
              //- Temperature
              template(v-slot:item.temperature="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.temperature" placeholder="0" outlined dense height="48" suffix="°C" type="number" hide-details="auto")
                div(v-else) {{ item.temperature ? `${item.temperature}°` : '' }}
              //- Blood pressure
              template(v-slot:item.blood_pressure="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.blood_pressure" placeholder="0/0" outlined dense height="48" :rules="sign.blood_pressure ? rules.valid_blood_pressure : []" hide-details="auto")
                div(v-else) {{ item.blood_pressure }}
              //- Pulse
              template(v-slot:item.pulse="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.pulse" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.pulse }}
              //- SpO2
              template(v-slot:item.spo2="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.spo2" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.spo2 }}
              //- Blood glucose
              template(v-slot:item.blood_glucose="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.blood_glucose" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.blood_glucose }}
              //- Respiratory rate
              template(v-slot:item.respiratory_rate="{ item, index }")
                v-text-field.text-sm.my-2.round-xl(v-if="item.editable" v-model="item.respiratory_rate" placeholder="0" outlined dense height="48" type="number" hide-details="auto")
                div(v-else) {{ item.respiratory_rate }}
              //- Actions
              template(v-slot:item.actions="{ item, index }")
                div.d-flex.align-center
                  v-btn(v-if="item.editable" icon small @click="saveSign(item)")
                    v-icon(color="neutral500") $yzi-save-01
                  v-btn(v-else icon small @click="item.editable = true")
                    v-icon(color="neutral500" size="22") $yzi-edit-02
                  v-btn.ml-3(icon small  @click="deleteSign(item)")
                    v-icon(color="neutral500") $yzi-trash-03

          //- Chart
          div
            v-card.neutral100.round-lg.mt-6.pa-6(flat)
              div.text-md.font-semibold.neutral700--text Vital trends
              div.d-flex.align-center.justify-space-between.mt-3
                div.text-sm.neutral700--text Show:
                template(v-for="(enabled, section) in sections")
                  div.ml-4
                    y-checkbox.mb-n2(v-model="sections[section]" @change="updateShowSections")
                      template(#label)
                        div.round-md.py-1.px-2(:style="`background-color: ${getSectionColor(section)}; color: ${getSectionTextColor(section)};`")
                          .text-sm.font-medium {{ getSectionText(section) }}
              apexchart(type="line" height="350" :options="chartOptions" :series="dataSeries")

    v-divider
    v-card-actions.px-6.white
      v-spacer
      v-btn.button-md(color="neutral700" depressed dark @click="closeDialog") {{ $t('done') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
    },
    patient: {
      type: Number,
      default: null
    },
    pid: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      showPicker: false,
      showTablePicker: false,
      selectedDateField: null,
      selectedDate: null,
      sign: {},
      signs: [],
      chartSigns: [],
      chartCategories: [],
      headers: [
        { text: 'Date', value: 'date', width: 170 },
        { text: 'Time', value: 'time', width: 170 },
        { text: 'Height', value: 'height' },
        { text: 'Weight', value: 'weight' },
        { text: 'Temp', value: 'temperature', width: 120 },
        { text: 'BP', value: 'blood_pressure', width: 120 },
        { text: 'Pulse', value: 'pulse' },
        { text: 'SpO2', value: 'spo2' },
        { text: 'BGL', value: 'blood_glucose' },
        { text: 'Resp rate', value: 'respiratory_rate' },
        { text: 'Actions', value: 'actions' },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_blood_pressure: [ v => /^\d+\/\d+$/.test(v) || 'Blood pressure must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      sections: 'clinic/getVitalSignsSections'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    chartOptions () {
      return {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: { enabled: false },
          toolbar: { show: false },
        },
        colors: this.colorSeries,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: 'Inter',
            fontWeight: 400
          },
          background: { 
            enabled: true,
            padding: 6,
            borderRadius: 4,
          },
        },
        stroke: { curve: 'straight' },
        grid: {
          borderColor: '#e7e7e7',
          row: { colors: ['#f3f3f3', 'transparent'], opacity: 0.5 },
          padding: { left: 30 }
        },
        markers: { size: 1 },
        xaxis: {
          categories: this.chartCategories
        },
        // yaxis: {
        //   max: 200,
        //   min: 0
        // },
        legend: { show: false }
      }
    },
    dataSeries () {
      let data = []
      if (this.chartSigns.length) {
        if (this.sections.height) {
          let heights = this.chartSigns.map(m => m.height)
          data.push({ name: 'Height', data: heights })
        }
        if (this.sections.weight) {
          let weight = this.chartSigns.map(m => m.weight)
          data.push({ name: 'Weight', data: weight })
        }
        if (this.sections.temperature) {
          let temperature = this.chartSigns.map(m => m.temperature)
          data.push({ name: 'Temperature', data: temperature })
        }
        if (this.sections.bpSys) {
          let bp_systolic = this.chartSigns.map(m => m.bp_systolic)
          data.push({ name: 'BP-SYS', data: bp_systolic })
        }
        if (this.sections.bpDia) {
          let bp_diastolic = this.chartSigns.map(m => m.bp_diastolic)
          data.push({ name: 'DP-DIA', data: bp_diastolic })
        }
        if (this.sections.pulse) {
          let pulse = this.chartSigns.map(m => m.pulse)
          data.push({ name: 'Pulse', data: pulse })
        }
        if (this.sections.spo2) {
          let spo2 = this.chartSigns.map(m => m.spo2)
          data.push({ name: 'SpO2', data: spo2 })
        }
        if (this.sections.blood_glucose) {
          let blood_glucose = this.chartSigns.map(m => m.blood_glucose)
          data.push({ name: 'Blood glucose', data: blood_glucose })
        }
        if (this.sections.respiratory_rate) {
          let respiratory_rate = this.chartSigns.map(m => m.respiratory_rate)
          data.push({ name: 'Respiratory rate', data: respiratory_rate })
        }
      }
      return data
    },
    colorSeries () {
      let data = []
      for (let key in this.sections) {
        if (this.sections[key]) {
          data.push(this.getSectionColor(key))
        }
      }
      return data
    }
  },
  watch: {
  },
  mounted () {
    this.fetchConsultationVitalSigns()
    this.fetchChartVitalSigns()
    this.updateCurrentDateTime()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchConsultationVitalSigns () {
      this.isFetching = true
      const params = {
        ordering: 'recorded_at',
        page_size: -1
      }
      this.$axios.get(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.signs = resp.data.results.map(m => {
              const parsedDatetime  = DateTime.fromISO(m.recorded_at)
              const date = parsedDatetime.toFormat('yyyy-MM-dd')
              const time = parsedDatetime.toFormat('HH:mm')
              const field_date = this.$options.filters.displayDate(date)
              let blood_pressure = null
              if (m.bp_systolic && m.bp_diastolic) {
                blood_pressure = `${m.bp_systolic}/${m.bp_diastolic}`
              }
              return { ...m, date, time, field_date, blood_pressure, editable: false }
            })
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchChartVitalSigns () {
      const params = {
        ordering: '-recorded_at',
        page_size: 10
      }
      this.$axios.get(`/clinics/${this.company.slug}/patients/${this.patient}/vital_signs`, { params })
        .then(resp => {
          let data = resp.data.results
          data.reverse()
          this.chartSigns = data
          this.chartCategories = data.map(m => this.$options.filters.convertServerDate2(m.recorded_at))
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pickDate (date) {
      this.selectedDateField = this.$options.filters.displayDate(date)
      this.$set(this.sign, 'date', date)
      this.showPicker = false
    },
    pickTableDate (item) {
      item.field_date = this.$options.filters.displayDate(item.date)
      this.showTablePicker = false
    },
    updateCurrentDateTime () {
      const now = DateTime.local()
      this.selectedDate = now.toFormat('yyyy-MM-dd')
      this.pickDate(this.selectedDate)
      this.$set(this.sign, 'time', now.toFormat('HH:mm'))
    },
    saveNewSign () {
      this.isLoading = true
      let data = { ...this.sign }
      data.recorded_at = `${this.sign.date} ${this.sign.time}`
      if (this.sign.blood_pressure) {
        data.bp_systolic = this.sign.blood_pressure.split('/')[0]
        data.bp_diastolic = this.sign.blood_pressure.split('/')[1]
      }
      this.$axios.post(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs`, data)
        .then(() => {
          this.sign = {}
          this.updateCurrentDateTime()
          this.fetchConsultationVitalSigns()
          this.fetchChartVitalSigns()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveSign (sign) {
      this.isFetching = true
      let data = { ...sign }
      data.recorded_at = `${sign.date} ${sign.time}`
      if (sign.blood_pressure) {
        data.bp_systolic = sign.blood_pressure.split('/')[0]
        data.bp_diastolic = sign.blood_pressure.split('/')[1]
      } else {
        data.bp_systolic = null
        data.bp_diastolic = null
      }
      data = this.sanitizeEmpty(data)
      this.$axios.patch(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs/${sign.id}`, data)
        .then(() => {
          this.fetchConsultationVitalSigns()
          this.fetchChartVitalSigns()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.isFetching = false
        })
    },
    sanitizeEmpty(data) {
      Object.keys(data).forEach(key => {
        if (data[key] === '' || data[key] === undefined || data[key] === null) {
          data[key] = null
        }
      })
      return data
    },
    deleteSign (sign) {
      this.isFetching = true
      this.$axios.delete(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs/${sign.id}`)
        .then(() => {
          this.fetchConsultationVitalSigns()
          this.fetchChartVitalSigns()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.isFetching = false
        })
    },
    updateShowSections () {
      const key = 'yz_vital_signs_sections'
      localStorage.setItem(key, JSON.stringify(this.sections))
    },
    getSectionText (item) {
      switch (item) {
        case 'height': {
          return 'Height'
        }
        case 'weight': {
          return 'Weight'
        }
        case 'temperature': {
          return 'Temperature'
        }
        case 'bpSys': {
          return 'BP-SYS'
        }
        case 'bpDia': {
          return 'BP-DIA'
        }
        case 'pulse': {
          return 'Pulse'
        }
        case 'spo2': {
          return 'SpO2'
        }
        case 'blood_glucose': {
          return 'Blood glucose'
        }
        case 'respiratory_rate': {
          return 'Respiratory rate'
        }
        default:
          return ''
      }
    },
    getSectionColor (item) {
      switch (item) {
        case 'height': {
          return '#0D6EFF'
        }
        case 'weight': {
          return '#14AE5C'
        }
        case 'temperature': {
          return '#C82F2F'
        }
        case 'bpSys': {
          return '#EB7100'
        }
        case 'bpDia': {
          return '#7F5AE9'
        }
        case 'pulse': {
          return '#FFDC61'
        }
        case 'spo2': {
          return '#20AFFF'
        }
        case 'blood_glucose': {
          return '#333333'
        }
        case 'respiratory_rate': {
          return '#3DFFD5'
        }
        default:
          return ''
      }
    },
    getSectionTextColor (item) {
      if (['pulse', 'respiratory_rate'].includes(item)) {
        return '#333333'
      } else {
        return '#FFFFFF'
      }
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-style {
    .v-data-table__wrapper {
      table {
        .v-data-table-header {
          tr {
            background-color: var(--v-neutral300);
          }
        }
      }
    }
  }
}
</style>